// Auto-generated sample data for Petpooja Dump dialog
// shifttoDayBeforeToday() shifts all restaurant_data dates so the last date = yesterday

export interface PetpoojaSampleData {
  form_data: Record<string, string>;
  restaurant_data: Array<{
    date: string;
    order_count: number;
    dine_in: number;
    home_delivery: number;
    take_away: number;
    zomato: number;
    swiggy: number;
    online_other: number;
    total: number;
  }>;
  restaurant_details: Record<string, string | number>;
}

export const PETPOOJA_SAMPLE_DATA: PetpoojaSampleData = {
  "form_data": {
    "firm_type": "Proprietorship",
    "business_age": "More than 2 Years",
    "required_amount": "500000",
    "alternate_mobile": "2342342341",
    "registered_mobile": "1231231231",
    "business_property_ownership": "Self-owned",
    "residential_property_ownership": "Rented"
  },
  "restaurant_data": [
    {
      "date": "2025-11-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-11-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-11-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2025-11-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2025-11-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-11-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-11-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-11-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-11-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-11-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2025-11-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2025-11-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-11-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2025-11-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-11-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-11-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2025-11-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-11-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-11-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2025-11-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-11-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-11-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-11-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-11-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-11-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-11-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2025-11-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2025-12-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2025-12-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-12-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2025-12-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2025-12-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2025-12-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-12-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-12-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-12-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-12-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-12-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-12-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2025-12-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2025-12-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-12-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-12-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2025-12-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2025-12-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2025-12-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2025-12-31",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-01-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2026-01-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2026-01-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-01-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-01-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-01-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-01-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-01-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2026-01-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-01-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-01-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-01-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-01-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2026-01-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-01-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-01-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-01-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2026-01-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-01-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2026-01-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-01-31",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-02-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-02-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-02-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-02-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10002
    },
    {
      "date": "2026-02-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-02-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-02-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-02-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-02-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2026-02-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-02-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-02-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2026-02-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-02-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2026-02-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-02-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-02-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-02-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-02-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-02-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10008
    },
    {
      "date": "2026-02-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2026-02-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-02-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-02-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-02-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10009
    },
    {
      "date": "2026-02-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10007
    },
    {
      "date": "2026-02-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10003
    },
    {
      "date": "2026-02-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10005
    },
    {
      "date": "2026-03-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18876
    },
    {
      "date": "2026-03-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-03-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-03-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-03-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-03-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-03-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-03-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-03-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18864
    },
    {
      "date": "2026-03-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-03-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-03-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-03-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-03-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-03-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-03-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-03-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18876
    },
    {
      "date": "2026-03-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-03-31",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-04-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-04-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-04-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-04-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-04-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-04-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-04-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-04-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-04-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-04-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18864
    },
    {
      "date": "2026-04-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-04-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18876
    },
    {
      "date": "2026-04-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-04-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-04-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18862
    },
    {
      "date": "2026-04-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-04-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-04-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18866
    },
    {
      "date": "2026-04-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-05-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18874
    },
    {
      "date": "2026-05-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 710
    },
    {
      "date": "2026-05-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-05-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-05-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 580
    },
    {
      "date": "2026-05-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 390
    },
    {
      "date": "2026-05-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 560
    },
    {
      "date": "2026-05-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 200
    },
    {
      "date": "2026-05-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 550
    },
    {
      "date": "2026-05-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18877
    },
    {
      "date": "2026-05-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 860
    },
    {
      "date": "2026-05-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-05-13",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 250
    },
    {
      "date": "2026-05-14",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18868
    },
    {
      "date": "2026-05-15",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 420
    },
    {
      "date": "2026-05-16",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 780
    },
    {
      "date": "2026-05-17",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 720
    },
    {
      "date": "2026-05-18",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 650
    },
    {
      "date": "2026-05-19",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 350
    },
    {
      "date": "2026-05-20",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18876
    },
    {
      "date": "2026-05-21",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18872
    },
    {
      "date": "2026-05-22",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 460
    },
    {
      "date": "2026-05-23",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18864
    },
    {
      "date": "2026-05-24",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 350
    },
    {
      "date": "2026-05-25",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 18870
    },
    {
      "date": "2026-05-26",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 320
    },
    {
      "date": "2026-05-27",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 750
    },
    {
      "date": "2026-05-28",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 380
    },
    {
      "date": "2026-05-29",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 820
    },
    {
      "date": "2026-05-30",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 480
    },
    {
      "date": "2026-05-31",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 210
    },
    {
      "date": "2026-06-01",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-06-02",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-06-03",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10006
    },
    {
      "date": "2026-06-04",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 600
    },
    {
      "date": "2026-06-05",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 790
    },
    {
      "date": "2026-06-06",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 820
    },
    {
      "date": "2026-06-07",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10001
    },
    {
      "date": "2026-06-08",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 10004
    },
    {
      "date": "2026-06-09",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 620
    },
    {
      "date": "2026-06-10",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 11000
    },
    {
      "date": "2026-06-11",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 11000
    },
    {
      "date": "2026-06-12",
      "order_count": 0,
      "dine_in": 0,
      "home_delivery": 0,
      "take_away": 0,
      "zomato": 0,
      "swiggy": 0,
      "online_other": 0,
      "total": 11000
    }
  ],
  "restaurant_details": {
    "restaurant_id": 100340,
    "restaurant_name": "Happy's Kitchen",
    "restaurant_created": "2024-05-29",
    "restaurant_pincode": "400601",
    "restaurant_owner_name": "Happy Singh",
    "restaurant_owner_phone": "9876543210",
    "restaurant_owner_email": "happy.singh@example.com"
  }
};

/**
 * Returns a copy of PETPOOJA_SAMPLE_DATA with all restaurant_data dates
 * shifted so that the last entry lands on yesterday (today - 1 day).
 */
export function shiftToYesterday(data: PetpoojaSampleData): PetpoojaSampleData {
  const rows = data.restaurant_data;
  if (rows.length === 0) return data;

  const lastDateStr = rows[rows.length - 1].date;
  const lastDate = new Date(lastDateStr + 'T00:00:00Z');

  const yesterday = new Date();
  yesterday.setUTCHours(0, 0, 0, 0);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);

  const diffMs = yesterday.getTime() - lastDate.getTime();
  const diffDays = Math.round(diffMs / 86400000);

  const shiftedRows = rows.map((row) => {
    const d = new Date(row.date + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + diffDays);
    return { ...row, date: d.toISOString().slice(0, 10) };
  });

  return { ...data, restaurant_data: shiftedRows };
}
